import { Button } from "@/components/ui/button";
import { ArrowUp, ArrowDown, Trash2 } from "lucide-react";
import { useTranslations } from "@/hooks/useTranslations";

interface ExerciseActionsProps {
  exerciseIndex: number;
  dayIndex: number;
  totalExercises: number;
  onRemoveExercise: (dayIndex: number, exerciseIndex: number) => void;
  onMoveExercise: (dayIndex: number, exerciseIndex: number, direction: 'up' | 'down') => void;
}

export function ExerciseActions({
  exerciseIndex,
  dayIndex,
  totalExercises,
  onRemoveExercise,
  onMoveExercise
}: ExerciseActionsProps) {
  const { t } = useTranslations("workouts");
  
  return (
    <div className="flex justify-end mt-4">
      <div className="flex gap-2">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onMoveExercise(dayIndex, exerciseIndex, 'up')}
          disabled={exerciseIndex === 0}
          className="h-8 w-8 p-0"
          title={t("exercises.moveUp")}
        >
          <ArrowUp className="h-4 w-4" />
        </Button>
        
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onMoveExercise(dayIndex, exerciseIndex, 'down')}
          disabled={exerciseIndex === totalExercises - 1}
          className="h-8 w-8 p-0"
          title={t("exercises.moveDown")}
        >
          <ArrowDown className="h-4 w-4" />
        </Button>
        
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => onRemoveExercise(dayIndex, exerciseIndex)}
          className="h-8 w-8 p-0 text-red-500 hover:text-red-600 hover:bg-red-50"
          title={t("newWorkout.exercises.removeExercise")}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
